/** Valores e textos da Aplicação de Exames (#606), sem componente. */
import { contar } from '../../components/applications/textosDoNivel';
import type { ValorDeCampo } from '../../components/applications/tipos';
import type { ExamWithApplication } from '../../types/examApplication';

export interface ValoresDoExame {
  isRequired: boolean;
  /** Null = sem periodicidade: o exame não entra na convocação periódica. */
  periodicityMonths: number | null;
}

export const OBRIGATORIO = 'obrigatorio';
export const OPCIONAL = 'opcional';
/** Na ação em lote, "sem periodicidade" é uma escolha; o nulo ali quer dizer "nada escolhido". */
export const SEM_PERIODICIDADE = 'sem';

export function nomeDaAplicacao(aplicacao: ExamWithApplication): string {
  return aplicacao.examName || `Exame ${aplicacao.examId}`;
}

export function textoDaPeriodicidade(meses: number | null | undefined): string {
  return meses ? contar(meses, 'mês', 'meses') : 'Sem periodicidade';
}

export function periodicidadeDoValor(valor: ValorDeCampo): number | null {
  return typeof valor === 'number' && valor > 0 ? valor : null;
}
